export const CubicBoxData = [
  {
    id: "1",
    icon: "images/Academies/tracks/infrastructure-new-brand.png",
    title: "Infrastructure Engineering",
    para: "The foundational layer that supports all enterprise systems—on-premises or cloud.",
    lists: [
      `<ul>
            <li>Managed Reinvention Services (MRS)</li>
            <li><a href='https://atci.lkm.delivery.accenture.com/TT/'>Infrastructure Engineering (IE)</a></li>
            <li>Infrastructure Managed Services (IMS)</li>
            <li><a href='https://atci.lkm.delivery.accenture.com/ApplicationManagementServices/'>Application Management Services (AMS)</a></li>
        </ul>`,
    ],
  },
  {
    id: "2",
    icon: "images/Academies/tracks/Cloud-Platform-new-brand.png",
    title: "Cloud Platforms",
    para: "Scalable and agile platforms that modernize infrastructure and enable digital transformation.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.accenture.com/CloudAcademy/AWS'>AWS</a></li>
            <li><a href='https://atci.lkm.accenture.com/CloudAcademy/Azure'>Azure </a></li>
            <li><a href='https://atci.lkm.accenture.com/CloudAcademy/GCP'>GCP </a></li>
        </ul>`,
    ],
  },
  {
    id: "4",
    icon: "images/Academies/tracks/Enterprise-platforms-new.png",
    title: "Enterprise Platforms",
    para: "Core systems of record and enterprise tools essential for business operations.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.eitacademy.accenture.com/SAPAcademy/Courses'>SAP</a></li>
            <li><a href='https://atci.lkm.eitacademy.accenture.com/Salesforce/Courses'>Salesforce</a></li>
            <li><a href='https://atci.lkm.eitacademy.accenture.com/Oracle/Courses'>Oracle</a></li>
            <li>Mainframe</li>
            <li>Commerce & Digital Business Solutions</li>
        </ul>`,
    ],
  },
  {
    id: "5",
    icon: "images/Academies/tracks/Enterprise-Integration-new.png",
    title: "Enterprise Integration and Automation",
    para: "Enabling connectivity, automation, and streamlined workflows across systems.",
    lists: [
      `<ul>
            <li>Enterprise Application Integration (EAI)</li>
            <li>Business Process Management (PEGA)</li>
            <li>Robotic Process Automation (RPA)</li>
            <li><a href='https://atci.lkm.accenture.com/LCNCAcademy/home'>Low-Code & No-Code (LCNC)</a></li>
        </ul>`,
    ],
  },
  {
    id: "6",
    icon: "images/Academies/tracks/software-engineering-new.png",
    title: "Software Engineering & Digital Development",
    para: "Developing scalable, user-centric applications on top of integrated platforms.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.accenture.com/JavaAcademy/home'>Java</a></li>
            <li>.Net</li>
            <li>Front-End Web Development (UI/UX)</li>
            <li>Next-Gen Programming Languages</li>
        </ul>`,
    ],
  },
  {
    id: "9",
    icon: "images/Academies/tracks/cybersecurity-new.png",
    title: "Security",
    para: "Protecting systems, data, and operations across the enterprise technology stack.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm-securitylearninghub.accenture.com/home'>Cyber Practices</a></li>
            <li><a href='https://atci.lkm-securitylearninghub.accenture.com/home'>Cyber Resilience</a></li>
            <li><a href='https://atci.lkm-securitylearninghub.accenture.com/home'>Cyber Protection</a></li>
            <li><a href='https://atci.lkm-securitylearninghub.accenture.com/home'>Cyber Strategy</a></li>
            <li><a href='https://atci.lkm-securitylearninghub.accenture.com/home'>Physical Security</a></li>
        </ul>`,
    ],
  },
  {
    id: "13",
    icon: "images/Academies/tracks/Sustainability-latest-brand.png",
    title: "Sustainability",
    para: "Sustainability in technology fosters Green software solutions that benefit businesses and reduce emissions for a healthier planet.",
    lists: [
      `<ul>
            <li><a href='https://atci.sustainability.accenture.com/learning?h=ls'>Sustainability</a></li>
        </ul>`,
    ],
  },
  {
    id: "14",
    icon: "images/Academies/tracks/Tech Delivery-new.png",
    title: "Tech Delivery",
    para: "Accelerating software delivery and infrastructure agility through automation and resilience.",
    lists: [
      {
        title: "Delivery Services",
        items: [
          { name: "SI", url: "https://atci.lkm.delivery.accenture.com/SystemIntegration/" },
          { name: "AMS", url: "https://atci.lkm.delivery.accenture.com/ApplicationManagementServices/" },
          { name: "MRS", url: "#" },
          { name: "IMS", url: "#" },
        ],
      },
      {
        title: "Delivery Practices/Methodologies",
        items: [
          { name: "Agile", url: "https://atci.lkm.delivery.accenture.com/Agile" },
          { name: "DevOps", url: "https://atci.lkm.delivery.accenture.com/DevOps/" },
          { name: "SRE", url: "https://atci.lkm.delivery.accenture.com/SRE/" },
          { name: "ITIL", url: "https://atci.lkm.delivery.accenture.com/ApplicationManagementServices/ITILearn" },
          { name: "Service Management", url: "https://atci.lkm.delivery.accenture.com/TT/ServiceIntergrationManagement/" },
          { name: "Agent Ops", url: "#" },
          { name: "Project Management", url: "https://atci.lkm.delivery.accenture.com/ProjectManagement/" },
          { name: "AI in TDLC", url: "https://atci.lkm.delivery.accenture.com/TT/Automation/genAI" },
          { name: "Frictionless SDLC", url: "#" },
        ],
      },
      {
        title: "Delivery Frameworks/Platforms",
        items: [
          { name: "MethodOne", url: "#" },
          { name: "Gen Wizard", url: "#" },
          { name: "ART", url: "#" },
          { name: "Reinvesion. AI", url: "#" },
          { name: "AI Delivery Studio", url: "#" },
          { name: "ServiceNow", url: "#" },
        ],
      },
      {
        title: "Delivery Leadership Programs",
        items: [
          { name: "SI-Elite SI Master Class", url: "https://atci.lkm.delivery.accenture.com/SystemIntegration/MasterClass" },
          { name: "SI Foundation Class", url: "https://atci.lkm.delivery.accenture.com/SystemIntegration/SIFC" },
          { name: "DSAS", url: "https://atci.lkm.delivery.accenture.com/leadershipprograms/DSAS" },
          { name: "DSOB", url: "https://atci.lkm.delivery.accenture.com/leadershipprograms/DSOB" },
          { name: "BCC", url: "https://atci.lkm.delivery.accenture.com/leadershipprograms/BCC" },
          { name: "UCC", url: "https://atci.lkm.delivery.accenture.com/leadershipprograms/UCC" },
          { name: "ADLE", url: "https://atci.lkm.delivery.ahttps://atci.lkm.delivery.accenture.com/ADLE/ccenture.com/ADLE" },
          { name: "DLE", url: "https://atci.lkm.delivery.accenhttps://atci.lkm.delivery.accenture.com/DLE/hometure.com/DLE/" },
        ],
      },
      {
        title: "Enterprise & Technology Architecture",
        items: [
          { name: "TA", url: "#" },
          { name: "STA", url: "#" },
          { name: "MTA", url: "#" },
          { name: "TOGAF", url: "#" },
          { name: "Cross Platform Architecture", url: "#" },
        ],
      },
    ],
  },
  {
    id: "15",
    icon: "images/Academies/tracks/Integrity-Engineering-new.png",
    title: "Integrity Engineering",
    para: "Ensuring reliability, performance, and test-driven development at every stage.",
    lists: [
      `<ul>
            <li>Test Automation</li>
            <li>Performance & Load Testing</li>
            <li>Functional & Non-Functional Testing</li>
            <li>Continuous Testing & DevTestOps</li>
        </ul>`,
    ],
  },
];
